import { Checkbox } from '@/components/ui/checkbox';
import { cn } from '@/lib/utils';

interface LineStyleControlsProps {
    curve: 'straight' | 'smooth';
    fill: boolean;
    fillGradient: boolean;
    disabled?: boolean;
    onCurveChange: (curve: 'straight' | 'smooth') => void;
    onFillChange: (fill: boolean) => void;
    onFillGradientChange: (gradient: boolean) => void;
}

const CURVES: { id: 'straight' | 'smooth'; label: string }[] = [
    { id: 'straight', label: 'Reta' },
    { id: 'smooth', label: 'Suave' },
];

/** Line-chart appearance: straight vs smooth line + area fill. */
export default function LineStyleControls({
    curve,
    fill,
    fillGradient,
    disabled = false,
    onCurveChange,
    onFillChange,
    onFillGradientChange,
}: LineStyleControlsProps) {
    return (
        <div>
            <label className="mb-2 block text-sm font-medium text-foreground">
                Estilo da linha
            </label>
            <div className="flex gap-1.5">
                {CURVES.map((option) => {
                    const active = curve === option.id;
                    return (
                        <button
                            key={option.id}
                            type="button"
                            disabled={disabled}
                            aria-pressed={active}
                            onClick={() => onCurveChange(option.id)}
                            className={cn(
                                'flex-1 rounded-lg border px-3 py-1.5 text-sm transition-colors disabled:cursor-not-allowed disabled:opacity-50',
                                active
                                    ? 'border-blue-500 bg-blue-50/50 text-blue-700'
                                    : 'border-border text-foreground hover:bg-surface',
                            )}
                        >
                            {option.label}
                        </button>
                    );
                })}
            </div>
            <label className="mt-2 flex cursor-pointer items-center gap-2.5 text-sm text-foreground">
                <Checkbox
                    checked={fill}
                    disabled={disabled}
                    onCheckedChange={(value) => onFillChange(value === true)}
                />
                Preencher área
            </label>
            {fill && (
                <label className="mt-2 flex cursor-pointer items-center gap-2.5 text-sm text-foreground">
                    <Checkbox
                        checked={fillGradient}
                        disabled={disabled}
                        onCheckedChange={(value) => onFillGradientChange(value === true)}
                    />
                    Preenchimento em degradê
                </label>
            )}
        </div>
    );
}
